import cn from 'classnames';
import { Link } from '#components/atoms/link/Link.tsx';
import { AuthLayout } from '#components/patterns/layouts/auth/AuthLayout.tsx';
import { SignupForm } from '../form/SignupForm.tsx';
import { GlowOrbIcon } from './GlowOrbIcon.tsx';
import styles from './Signup.module.css';

type Props = {
  onSuccessfulSubmit: () => void;
};

export function Signup({ onSuccessfulSubmit }: Props) {
  return (
    <AuthLayout
      headerText={
        <div>
          Already have an account?{' '}
          <Link className="a" to="/auth/login">
            Sign in
          </Link>
        </div>
      }
    >
      <div className="simple-page-content">
        <h1 className="h2 mb-32">Get started for free</h1>
        <ul className={cn('mt-0 mb-32', styles.Signup_glowOrbList)}>
          <li className="p">
            <GlowOrbIcon /> Simply manage connectivity between hosts
          </li>
          <li className="p">
            <GlowOrbIcon />
            Create a network of up to 100 hosts for free
          </li>
          <li className="p">
            <GlowOrbIcon />
            Support for Linux, Windows, macOS, iOS, and Android
          </li>
        </ul>
        <SignupForm onSuccessfulSubmit={onSuccessfulSubmit} />
      </div>
    </AuthLayout>
  );
}
